// capture-guard.js — ¿se puede CAPTURAR offline ahora mismo?
//
// Dos lecturas, una por modulo:
//
//   - `isOfflineStorageReady()`: Formularios. Solo mira si la base esta abierta; Formularios no lee la
//     bandera `offline_mode_enabled`.
//   - `isOfflineCaptureReady()`: Tareas. La bandera `offline_mode_enabled` (que decide si Tareas
//     captura offline) Y la base abierta.
//
// La bandera no dice nada sobre si la base esta abierta. Cuando el arranque se cae (ISS-1009:
// `boot.open` revienta por timeout de 20s; 331 usuarios en 90 dias), `StorageAdapter._backend` queda
// en null: cada escritura se va igual a SQLite y falla, con la red perfectamente disponible. El
// usuario ve "Error al guardar los cambios" en una app que podria haber guardado por el camino
// online de siempre.
//
// El docblock de `StorageAdapter.isReady()` ya decia que hacer en ese caso:
//
//   > el llamador debe degradar al flujo online de siempre en vez de encolar en SQLite y fallar
//
// Este modulo es esa condicion en UN solo lugar, para que ningun call-site tenga que acordarse de
// la mitad del guard. Va en los puntos que DECIDEN entre capturar offline o irse al camino online.
//
// LECTURA PUNTUAL vs REACTIVA — importa cual se usa:
//
//   - En el cuerpo de un metodo o action va ESTA funcion. Se evalua en el instante de la escritura,
//     que es exactamente lo que se quiere saber.
//   - En un `computed` o en el template NO: la lectura puntual se congela en el valor del primer
//     render y la UI sigue mintiendo cuando la base se cae o vuelve a abrir. Ahi va el ref reactivo
//     `storageReady` de StorageAdapter, como ya hace Occurrence.vue.
//
// No tiene efectos secundarios: no abre, no reabre, no toca el write-lock.

import { isFlagEnabled } from './flags'
import { StorageAdapter } from './storage/StorageAdapter'

/** Tareas: true solo si la bandera esta encendida Y la base esta realmente abierta. */
export function isOfflineCaptureReady () {
  return isFlagEnabled('offline_mode_enabled') && StorageAdapter.isReady()
}

/** Formularios: true si la base esta abierta, sin mirar la bandera. */
export function isOfflineStorageReady () {
  return StorageAdapter.isReady()
}
